/* eslint-disable no-lonely-if */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import moment from 'moment';

import {
  Row, Col, Label, Button, InputGroup,
  Card, CardBody, CardHeader, Table,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';

import { get, post } from '../../helpers/api_helper';

function TVForm(props) {
  const {
    t, sjn, onCancel, onSuccess,
  } = props;

  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [addressing, setAddressing] = useState([]);
  const [tv, setTV] = useState(null);
  const brandRef = useRef(null);
  const modelRef = useRef(null);
  const serialRef = useRef(null);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const result = await get('/api/devices/brands');

        setBrands(result);
      } catch (err) {
        toastr.error(t('Error loading brands'), t('Error'));
      }
    };

    fetchBrands();
  }, []);

  useEffect(() => {
    const fetchTVBySJN = async () => {
      try {
        const data = await get(`/api/tvs/${sjn}`);

        setTV(data);
      } catch (error) {
        toastr.error(error.message, 'Error');
      }
    };

    const fetchTVByID = async () => {
      try {
        const data = await get(`/api/tvs/id/${sjn}`);

        setTV(data);
      } catch (error) {
        toastr.error(error.message, 'Error');
      }
    };

    if (sjn !== null && sjn.match(/^[A-Z0-9]{4}$/)) {
      fetchTVBySJN();
    }

    if (sjn !== null && sjn.match(/^[0-9]{6}$/)) {
      // TV ID
      fetchTVByID();
    }
  }, [sjn]);

  const save = async (values) => {
    try {
      if (loading) return;

      setLoading(true);

      const tvData = await post('/api/tvs', values);

      // await get(`/api/tvs/print/${tvData.id}`);

      props.onSuccess();
    } catch (error) {
      toastr.error(t('Error inducting TV'), t('Error'));
    } finally {
      setLoading(false);
    }
  };

  const loadModels = async () => {
    try {
      const result = await get(`/api/devices/models?brand=${encodeURIComponent(brandRef.current.value)}`);

      setModels(result);
    } catch (err) {
      toastr.error(t('Error loading models'), t('Error'));
    }
  };

  const ValidationSchema = Yup.object().shape({
    serial: Yup.string(),
    device: Yup.object().shape({
      id: Yup.number(),
    }),
    brand: Yup.string().required(t('Brand is required')),
    model: Yup.string().required(t('Model is required')),
    version: Yup.string().nullable(),
  });

  const jsx = (
    <Formik
      enableReinitialize
      initialValues={tv || {}}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        save(values);
      }}
    >
      {({
        touched, errors, values, setFieldValue,
      }) => (
        <Form id="TVForm" autoComplete="off">
          <Row className="pb-3 mb-3">
            <Col sm="8">
              <Label
                for="serial"
                className="pe-0 ps-0"
              >
                {props.t('Serial')}
              </Label>
              <Field
                type="text"
                className={`form-control input-lg ${(errors.serial && touched.serial ? 'is-invalid' : '')}`}
                id="serial"
                name="serial"
                innerRef={serialRef}
                onKeyDown={async (e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();

                    setTimeout(() => {
                      modelRef.current.focus();
                    }, 200);
                  }
                }}
              />
              <div className="help-block text-muted pt-1">
                {props.t('Serial number on the TV')}
              </div>
              <ErrorMessage
                name="serial"
                component="div"
                className="text-danger"
              />
            </Col>
          </Row>

          <Row className="pb-3">
            <Col sm="6">
              <Label
                for="brand"
                className="pe-0 ps-0"
              >
                {props.t('Brand')}
              </Label>
              <div className="position-relative">
                <Field
                  type="text"
                  innerRef={brandRef}
                  className={`form-control input-lg ${(errors.brand && touched.brand ? 'is-invalid' : '')}`}
                  id="brand"
                  name="brand"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                    }

                    if (e.key === 'ArrowDown') {
                      e.preventDefault();
                    }

                    setFieldValue('model', '');
                    setFieldValue('device_id', null);
                  }}
                />
                {values.brand && values.brand.length > 0
                  && (brandRef.current == document.activeElement
                    || !brands.includes(values.brand))
                  && (
                    <div className="position-absolute" style={{ width: '100%', marginTop: '1px', zIndex: 100 }}>
                      <ul className="list-group">
                        {brands.filter((brand) => (
                          brand.toLowerCase().startsWith(values.brand.toLowerCase())
                        )).map((brand) => (
                          <li
                            key={brand.id}
                            className="list-group-item position-relative"
                            style={{ padding: '0px' }}
                          >
                            <a
                              href="#"
                              className="text-dark"
                              style={{ display: 'block', padding: '0.47rem 0.75rem' }}
                              onClick={(e) => {
                                e.preventDefault();
                                setFieldValue('brand', brand);

                                setTimeout(() => {
                                  modelRef.current.focus();
                                }, 100);
                              }}
                            >
                              {brand}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                <ErrorMessage
                  name="brand"
                  component="div"
                  className="text-danger"
                />
              </div>
            </Col>

            {values.brand && values.brand.length > 0 && brands.includes(values.brand) && (
            <Col sm="6">
              <Label
                for="model"
                className="pe-0 ps-0"
              >
                {props.t('Model')}
              </Label>
              <div className="position-relative">
                <Field
                  type="text"
                  className={`form-control input-lg ${(errors.model && touched.model ? 'is-invalid' : '')}`}
                  id="model"
                  name="model"
                  innerRef={modelRef}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                    }
                  }}
                  onFocus={() => {
                    loadModels();
                  }}
                />
                {values.model && values.model.length > 0
                  && (modelRef.current == document.activeElement
                    || models.filter((mdl) => mdl.model === values.model).length === 0)
                  && (
                    <div className="position-absolute" style={{ width: '100%', marginTop: '1px', zIndex: 100 }}>
                      <ul className="list-group">
                        {models.filter((mdl) => (
                          mdl.model.toLowerCase().startsWith(values.model.toLowerCase())
                        )).map((model) => (
                          <li
                            key={model.id}
                            className="list-group-item position-relative"
                            style={{ padding: '0px' }}
                          >
                            <a
                              href="#"
                              className="text-dark"
                              style={{ display: 'block', padding: '0.47rem 0.75rem' }}
                              onClick={(e) => {
                                e.preventDefault();

                                setFieldValue('model', model.model);
                                setFieldValue('device', model);
                              }}
                            >
                              {model.model}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                <ErrorMessage
                  name="model"
                  component="div"
                  className="text-danger"
                />
              </div>
            </Col>
            )}
          </Row>

          {values.device === null && (
            <div className="text-danger">
              {props.t('No model linked')}
            </div>
          )}

          <style>
            {`
              .list-group-item a:focus {
                background-color: rgba(249, 195, 25, 1) !important;
              }
            `}
          </style>
          <Row>
            <Col sm="6">
              <Label
                for="version"
                className="pe-0 ps-0"
              >
                {props.t('Version')}
              </Label>
              <Field
                type="text"
                className={`form-control input-lg ${(errors.version && touched.version ? 'is-invalid' : '')}`}
                id="version"
                name="version"
              />
              <ErrorMessage
                name="version"
                component="div"
                className="text-danger"
              />
            </Col>
          </Row>

          <Button size="sm" color="dark" className="ml-2 mt-3 btn-soft-dark" onClick={() => { onCancel(); }}>{t('Cancel')}</Button>
          <Button size="sm" color="success" className="ms-2 mt-3 btn-soft-success" type="submit">{t('Save')}</Button>
        </Form>
      )}
    </Formik>
  );

  return jsx;
}

TVForm.defaultProps = {
  onSuccess: () => {},
  onCancel: () => {},
};

TVForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  onSuccess: PropTypes.func,
  sjn: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(TVForm));
